import { isSessionEndedError } from '@papan/api-client'

/**
 * The app's query retry: one retry, as before — except for a read refused because the active identity changed
 * (`IdentityChangedError`, @papan/files, #1210). Retrying that would re-run the query on its old key with the NEW
 * identity's headers. Matched by name, so this module (and `main.tsx`) imports nothing from the files feature.
 */
export function queryRetry(failureCount: number, error: unknown): boolean {
  if ((error as Error | null)?.name === 'IdentityChangedError') return false
  // #1316: a query dropped because the session ended must not run again under the next session
  if (isSessionEndedError(error)) return false
  return failureCount < 1
}
